export default {
  Ungrouped: [
      // 'response',
      'tissue_level',
      'sex',
      'age_group',
      // 'cohort',
      'tumor_stage',
      
      'Death',
      'Death or Progression',
      // 'event_status',
      // 'PFS_event_status',
      'Radiation-therapy',
      'Chemo-therapy',
      'Immuno-therapy',
      'Targeted-therapy',
      'BRAF_hotspot',
      'NRAS_hotspot',
      // 'KRAS_hotspot',
      'transcriptional_state_classification',
      'SNF_group_of_interest',
      'ubi_cluster',
      'ICI_cluster',
      'glyco cluster'
      // 'ethnicity'
    ],
  Mutation: [
          'ARID1A', 'ARID2', 'ATRX', 'BRAF',	
                 'NRAS', 'NF1', 'TERT', 'TP53'
  ],
  // Chromosome_gain: ["gain_chr7", "gain_chr17"],
  // Chromosome_loss: ["loss_chr1", "loss_chr3p", "loss_chr14q"],
  // Numerical: [],
};
